import { motion } from "framer-motion";

const ProgressBar = () => {
  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-sm">
      <div className="container mx-auto px-6 py-4">
        <div className="h-2 bg-blue-100 rounded-full">
          <motion.div
            className="h-full bg-blue-600 rounded-full"
            initial={{ width: "0%" }}
            animate={{ width: "33.33%" }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          />
        </div>
        <p className="text-blue-600 text-sm mt-2 font-semibold">
          Step 1: Choose Your Plan
        </p>
      </div>
    </div>
  );
};

export default ProgressBar;
